/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component, useState } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import i18n from "i18next";
import some from 'lodash/some';

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';
import { Button } from 'primereact/button';

class ModalCheckboxCm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      originalOptionsSelect: [],
      optionsSelect: [],
      deleteOptionsSelect: [],
      mode: 'edit',
      addText: '',
      addValue: '',
      errorsAdd: {},
    }
  }

  componentDidMount() {
    const { target } = this.props
    const getOptions = []
    for (let i = 0; i < target.options.length; i += 1) {
      getOptions.push({text: target.options[i].text, value: target.options[i].value})
    }

    this.setState({
      originalOptionsSelect: [...getOptions],
      optionsSelect: [...getOptions],
      deleteOptionsSelect: [...getOptions],
      loadingPage: false
    })
  }

  onEdit = async () => {
    const { onEditAction, onHidden } = this.props
    const { optionsSelect } = this.state
    const validateEmpty = optionsSelect.reduce((empty, item) => {
      if (!item.text) empty = true
      return empty
    }, false)

    if (validateEmpty) return true // No hace accion aceptar hastas que no contenga algun valor vacio

    onEditAction({optionsSelect})
    return onHidden()
  }

  addOption = async () => {
    const { addText, addValue} = this.state
    const { onAddAction, onHidden } = this.props
    const validate = await this.validateFieldsAdd()
    if (some(validate, {})) return true
    onAddAction(addText, addValue)
    return onHidden()

  }

  deleteOption = async () => {
    const { onDeleteAction, onHidden } = this.props
    const { deleteOptionsSelect } = this.state

    onDeleteAction({deleteOptionsSelect})
    return onHidden()

  }

  validateFieldsAdd = async () => {
    const { t } = this.props
    const { addText, addValue } = this.state
    let errorsAdd = {}
    if (!addText) errorsAdd = {...errorsAdd, [`addText`]: `${t('Texto de la opción')} ${t('es requerido')}`}
    if (!addValue) errorsAdd = {...errorsAdd, [`addValue`]: `${t('Valor')} ${t('es requerido')}`}
    this.setState({errorsAdd})
    return errorsAdd
  }


  onChangeOpt = (option, index) => {
    const { optionsSelect } = this.state
    const newOptions = optionsSelect;
    newOptions[index] = option
    this.setState({optionsSelect:  newOptions })
  }

  onDeleteOpt = (target, index) => {
    const { deleteOptionsSelect } = this.state
    let newOptions = deleteOptionsSelect;
    newOptions = newOptions.filter((item, i) => i !== index)
    // newOptions[index] = target.value
    this.setState({deleteOptionsSelect:  newOptions })
  }

  onChangeSimple = ({target}) => {
    this.setState({[target.name]: target.value}, () => this.validateFieldsOnchange(target.name, target.value))
  }

  validateFieldsOnchange = (name, value) => {
    const { errorsAdd } = this.state
    if (errorsAdd[name] && value) {
      delete errorsAdd[name]
      this.setState({errorsAdd})
    }
  }

  switchMode = (type) => {
    if (type === 'edit') this.setState((prevState ) => ({ optionsSelect: [...prevState.originalOptionsSelect] }))
    if (type === 'delete') this.setState((prevState ) => ({ deleteOptionsSelect: [...prevState.originalOptionsSelect] }))
    this.setState({mode: type})
  }
  
  render () {
    const { t, title, onHidden, label, btnOkLabel, isAddRemoveElements } = this.props
    const { optionsSelect, deleteOptionsSelect, loadingPage, mode, addText, addValue, errorsAdd } = this.state

    const isFormFieldValid = (name) =>
      !!(errorsAdd[name]);
    const getFormErrorMessage = (name) =>
    isFormFieldValid(name) && (
      <small className="p-error">{errorsAdd[name]}</small>
    );

    const renderOptions = optionsSelect.map((item, index) => (
      <div className='p-col-12'>
        <InputsOptions
            value={item}
            key={item}
            disabledEditValue={!isAddRemoveElements}
            onChange={(e) => this.onChangeOpt(e, index)}
        />
      </div>
    ))

    const renderDeleteOptions = deleteOptionsSelect.map((item, index) => {
      const {length} = deleteOptionsSelect
      return (
      <div className="p-col-12 p-py-1">
        <div className="p-inputgroup">
            <span className="p-inputgroup-addon cursor-pointer" onClick={length > 1 ? ()=> this.onDeleteOpt(item, index) : () => {}}><i className="pi pi-trash"></i></span>
            <InputText
              value={item.text}
              disabled
            />
        </div>
      </div>
      )
    })

    const formEdit = (
        <div className="p-mt-2 p-fluid p-grid">
        { isAddRemoveElements && (
          <div className='p-col-12 p-d-flex p-jc-end'>
            <Button
              type="button"
              icon="pi pi-plus"
              className="p-button-secondary p-mr-1"
              tooltip={t('Agregar opción')}
              onClick={() => this.switchMode('add')}
            />
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-secondary"
              tooltip={t('Eliminar opcion')}
              onClick={() => this.switchMode('delete')}
            />
          </div>
        )}
        <div className="p-col-12">
          <label className="">{label || t('Configura el texto de las opciones contenidas en el campo seleccionado')}</label>
        </div>

        <div className='p-col-6'>
          <label className='p-text-bold'>{t('Texto')}</label>
        </div>
        <div className='p-col-6'>
          <label className='p-text-bold'>{t('Valor')}</label>
        </div>

        { renderOptions }

        <div className="p-dialog-footer custom p-col-12">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="button" onClick={this.onEdit}>
              <span className="p-button-label p-c">{btnOkLabel || 'Guardar'}</span>
            </button>
          </div>
        </div>
      </div>
    )

    const formAdd = (
        <div className="p-mt-2 p-fluid p-grid">
        <div className='p-col-12 p-d-flex p-jc-end'>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-secondary p-mr-1"
            tooltip={t('Editar opciones')}
            onClick={() => this.switchMode('edit')}
          />
          <Button
            type="button"
            icon="pi pi-trash"
            className="p-button-secondary"
            tooltip={t('Eliminar opcion')}
            onClick={() => this.switchMode('delete')}
          />
        </div>
        <div className="p-col-12">
          <label className="">{t('Agregar nueva opción')}</label>
        </div>

        <div className='p-col-12'>
          <label>{t('Texto de la opción')}</label>
          <InputText
            value={addText}
            name="addText"
            onChange={this.onChangeSimple}
          />
          {getFormErrorMessage(`addText`)}
        </div>
        <div className='p-col-12'>
          <label>{t('Valor')}</label>
          <InputText
            value={addValue}
            name="addValue"
            onChange={this.onChangeSimple}
          />
          {getFormErrorMessage(`addValue`)}
        </div>

        <div className="p-dialog-footer custom p-col-12">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button>
            <button className="p-button p-component" type="button" onClick={this.addOption}>
              <span className="p-button-label p-c">{t('Guardar')}</span>
            </button>
          </div>
        </div>
      </div>
    )

    
    const formDelete = (
      <div className="p-mt-2 p-fluid p-grid">
      <div className='p-col-12 p-d-flex p-jc-end'>
        <Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-secondary p-mr-1"
          tooltip={t('Editar opciones')}
          onClick={() => this.switchMode('edit')}
        />
        <Button
          type="button"
          icon="pi pi-plus"
          className="p-button-secondary"
          tooltip={t('Agregar opción')}
          onClick={() => this.switchMode('add')}
        />
      </div>
      <div className="p-col-12">
        <label className="">{label || t('Elimina las opciones que deseas desaparecer')}</label>
      </div>

      { renderDeleteOptions }

      <div className="p-dialog-footer custom p-col-12">
        <div>
          <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
            <span className="p-button-label p-c">Cerrar</span>
          </button> 
          <button className="p-button p-component" type="button" onClick={this.deleteOption}>
            <span className="p-button-label p-c">{btnOkLabel || 'Guardar'}</span>
          </button>
        </div>
      </div>
    </div>
  )


    const renderMode = () => {
      switch (mode) {
        case 'edit':
          return formEdit
        case 'add':
          return formAdd
        case 'delete':
          return formDelete
        default:
          break;
      }
    }


    const children = loadingPage ? '' : renderMode() 

    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Dropdown')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '40vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps))(ModalCheckboxCm)



const InputsOptions = ({ value, onChange, disabledEditValue=false }) => {
  const [onValue, setValue] = useState(value)

  return (
    <div className='p-grid'>
      <div className="p-col-6 p-py-1">
        <div className="p-inputgroup">
            <span className="p-inputgroup-addon"><i className='pi pi-info'></i></span>
            <InputText
              value={onValue.text}
              onChange={(e) => setValue({...onValue, text: e.target.value})}
              onBlur={() => onChange(onValue)}
            />
        </div>
        { ! onValue && <small className="p-error">{i18n.t('Opcion requerida')}</small>}
      </div>
      <div className="p-col-6 p-py-1">
        <div className="p-inputgroup">
            <span className="p-inputgroup-addon">{'< >'}</span>
            <InputText
              value={onValue.value}
              onChange={(e) => setValue({...onValue, value: e.target.value})}
              onBlur={() => onChange(onValue)}
              disabled={disabledEditValue}
            />
        </div>
        { ! onValue && <small className="p-error">{i18n.t('Opcion requerida')}</small>}
      </div>
    </div>
  );
};
